import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountForPrimaryNavPanelQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountForPrimaryNavPanelQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, displayName?: string | null, imageUrl?: string | null, tier?: Types.AccountTier | null, version?: number | null, subscription: { __typename?: 'AccountSubscription', id: string, limitedResources?: { __typename?: 'LimitedResources', workspaces?: { __typename?: 'LimitedResource', limit53?: number | null } | null } | null } } | null };


export const GetAccountForPrimaryNavPanel = /*#__PURE__*/ gql`
    query GetAccountForPrimaryNavPanel($accountId: ID!) {
  account(accountId: $accountId) {
    id
    displayName
    imageUrl
    tier
    version
    subscription {
      id
      limitedResources {
        workspaces {
          limit53
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAccountForPrimaryNavPanelQuery, GetAccountForPrimaryNavPanelQueryVariables>;

          

          export const useGetAccountForPrimaryNavPanelQuery = (options?:QueryHookOptions<GetAccountForPrimaryNavPanelQuery, GetAccountForPrimaryNavPanelQueryVariables>) => useQuery(GetAccountForPrimaryNavPanel, options);

          

          export type GetAccountForPrimaryNavPanelQueryOptions = QueryHookOptions<GetAccountForPrimaryNavPanelQuery, GetAccountForPrimaryNavPanelQueryVariables>;

          

          export const useGetAccountForPrimaryNavPanelLazyQuery = (options?:LazyQueryHookOptions<GetAccountForPrimaryNavPanelQuery, GetAccountForPrimaryNavPanelQueryVariables>) => useLazyQuery(GetAccountForPrimaryNavPanel, options);

          

          export type GetAccountForPrimaryNavPanelQueryResult = ReturnType<typeof useGetAccountForPrimaryNavPanelQuery>;

          
